// React
import React, { useRef, useState } from 'react';
// Assets
import UploadIcon from '../../assets/upload.png';
// Components
import Tooltip, { TooltipContent, TooltipTrigger } from '../Tooltip';
// Styles
import { Dropzone, DropzoneInput, DropzoneMessage, DropzoneTitle } from './StyledDropzone';

const UploaderComponent = ({ title, tooltip, fileCallback }) => {
    const [dropzoneActive, setDropzoneActive] = useState(false);

    const fileInputRef = useRef();

    const dragOver = (e) => {
        setDropzoneActive(true)
        e.preventDefault();
    }

    const dragEnter = (e) => {
        setDropzoneActive(true)
        e.preventDefault();
    }

    const dragLeave = (e) => {
        setDropzoneActive(false)
        e.preventDefault();
    }

    const fileDrop = (e) => {
        setDropzoneActive(false)
        e.preventDefault()
        const files = e.dataTransfer.files;
        if (files.length) {
            handleFiles(files);
        }
    }

    const filesSelected = () => {
        handleFiles(fileInputRef.current.files);
    }

    const fileInputClicked = () => {
        fileInputRef.current.click()
    }

    const handleFiles = (files) => {
        for (let i = 0; i < files.length; i++) {
            fileCallback(files[i])
        }
    }

    return (
        <>
            <DropzoneTitle>
                {title}
                <Tooltip id="track-tip">
                    <TooltipTrigger>
                        <i className="fas fa-question-circle"></i>
                    </TooltipTrigger>
                    <TooltipContent>
                        {tooltip}
                    </TooltipContent>
                </Tooltip>
            </DropzoneTitle>
            <Dropzone
                active={dropzoneActive}
                onDragOver={dragOver}
                onDragEnter={dragEnter}
                onDragLeave={dragLeave}
                onDrop={fileDrop}
                onClick={fileInputClicked}
            >
                <DropzoneMessage>
                    <DropzoneInput
                        multiple
                        type="file"
                        ref={fileInputRef}
                        onChange={filesSelected}
                    />
                    <img src={UploadIcon} alt="upload_image" style={{ width: '100px', height: 'auto' }} />
                    Drag and drop files here or click to upload
                </DropzoneMessage>
            </Dropzone>
        </>
    );
};

export default UploaderComponent;